import { CircularProgress, Typography } from '@mui/material';
import styles from './ConditionalRenderQuery.module.css';
import Failure from './Failure';

export interface IConditionalRenderQuery {
  status: 'success' | 'error' | 'pending';
  success: () => React.ReactNode;
  failure?: () => React.ReactNode;
  loading?: React.ReactNode;
  children?: React.ReactNode;
}

const ConditionalRenderQuery: React.FC<IConditionalRenderQuery> = ({ status, success, failure, loading, children }) => {
  switch (status) {
    case 'success':
      return <>{success()}</>;
    case 'error':
      return <>{failure ? failure() : <Failure />}</>;
    case 'pending':
      return <Typography className={styles.loading}>Pending...</Typography>;
    default:
      return <>{children ? children : <CircularProgress />}</>;
  }
};

export default ConditionalRenderQuery;
